import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/AboutUsPage/aboutUsPage.js");
